export default function CTASection() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      alert('订阅成功！感谢您的关注。');
      form.reset();
      return;
    }

    try {
      const body = new URLSearchParams();
      body.append('email', formData.get('email') as string);
      body.append('source', 'homepage-cta');

      await fetch('https://readdy.ai/api/form/d92geqlpggnemm8f9th0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      alert('订阅成功！最新黑料热瓜将第一时间送达您的邮箱。');
      form.reset();
    } catch {
      alert('订阅失败，请稍后重试。');
    }
  };

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-3xl mx-auto text-center">
        {/* Image */}
        <div className="rounded-2xl overflow-hidden mb-10 mx-auto max-w-lg">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20artistic%20composition%20with%20dark%20green%20and%20warm%20amber%20gradients%2C%20floating%20geometric%20shapes%20like%20whispering%20secrets%2C%20mysterious%20elegant%20atmosphere%20with%20soft%20light%20leaks%2C%20editorial%20design%20aesthetic%20with%20cinematic%20depth%2C%20minimal%20but%20striking%20composition%20with%20organic%20curves%20and%20subtle%20texture%2C%20no%20text%20no%20people%20just%20pure%20visual%20art&width=800&height=400&seq=cta-newsletter-v1&orientation=landscape"
            alt="订阅51fun吃瓜爆料"
            className="w-full h-auto object-cover"
          />
        </div>

        {/* Text */}
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
          不想错过任何一个<span className="text-accent-600 italic font-heading">瓜</span>？
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-md mx-auto leading-relaxed">
          订阅51fun吃瓜爆料，最新网红翻车、明星八卦第一时间送到你手上！
        </p>

        {/* Form */}
        <form
          data-readdy-form
          id="homepage-newsletter"
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            placeholder="输入你的邮箱地址"
            required
            className="w-full sm:flex-1 px-5 py-3 rounded-full bg-background-50 border border-background-300 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-accent-500 transition-colors"
          />
          <button
            type="submit"
            className="whitespace-nowrap cursor-pointer w-full sm:w-auto px-8 py-3 rounded-full bg-secondary-900 text-background-50 text-sm font-medium hover:bg-secondary-800 transition-all"
          >
            免费订阅
            <div className="w-4 h-4 inline-flex items-center justify-center ml-1">
              <i className="ri-send-plane-line text-xs"></i>
            </div>
          </button>

          {/* Honeypot */}
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            className="absolute opacity-0 pointer-events-none"
          />
        </form>
      </div>
    </section>
  );
}